/* eslint-disable valid-jsdoc */
import _ from 'underscore';
import { Activity } from 'botframework-directlinejs';
import {
  EVENT_NAME_ENGAGE_TROUBLESHOOTER,
  PluginScenarios,
  EVENT_NAME_PLUGIN,
  PluginScenarioTroubleshootingDetection,
  EVENT_NAME_LIVE_AGENT_CHAT,
  isAccountSwitchReaction,
} from '../../utils';
/**
 * Returns true if the activity should be displayed in the conversation thread.
 */
export function shouldDisplayInConversationThread({
  activity,
  isTroubleshootingEnabled,
  isReportingInsightsEnabled,
}: {
  activity: Activity;
  isTroubleshootingEnabled: boolean;
  isReportingInsightsEnabled: boolean;
}): boolean {
  if (activity.type === 'message') {
    return true;
  }
  if (isAccountSwitchReaction(activity)) {
    return true;
  }
  if (activity.type === 'event') {
    if (activity.name === EVENT_NAME_LIVE_AGENT_CHAT) {
      return true;
    }
    const isTroubleshootingEvent = isTroubleshootingEnabled && activity.name === EVENT_NAME_ENGAGE_TROUBLESHOOTER;
    const isReportingPlugin = isReportingInsightsEnabled && activity.name === EVENT_NAME_PLUGIN && _.any(activity.value, pluginResult => _.contains(PluginScenarios, pluginResult.Name));
    const isTroubleshootingIntentionPlugin = isTroubleshootingEnabled
      && activity.name === EVENT_NAME_PLUGIN
      && _.any(activity.value, pluginResult => pluginResult.Name === PluginScenarioTroubleshootingDetection);
    return isTroubleshootingEvent || isReportingPlugin || isTroubleshootingIntentionPlugin;
  }
  return false;
}
